export interface FeatureFlags {
  showBandsSection: boolean;
}

export const fetchFeatureFlags = async (): Promise<FeatureFlags> => {
  try {
    const res = await fetch("/config/featureFlags.json", { cache: "no-cache"});
    return await res.json();
  } catch (err) {
    console.error("Impossible de charger les feature flags", err);
    return { showBandsSection: false };
  }
};